const FoundationContentData = {
  title: "THE INSPIRING STORY BEHIND ",
  title2: "OUR FOUNDATION",
  description: `Founded in 2022, DNCC is dedicated to promoting equality in disability and healthcare services. Our vision is to empower individuals with disabilities through personalized and person-centered support. As an NDIS Disability Support provider, our mission revolves around empowering individuals to take control of their lives. With the invaluable expertise of Suman and Kadam in the healthcare field, we consistently deliver high-quality services to make our vision a reality.`,
};

export default FoundationContentData;
